import React, {useRef, useState} from 'react';
import styles from './styles';
import {InOutAnimation as Animation, Button} from '@xpertdox_js/xdcomponents';
import {DataTableContext} from '../../Utils/DataTableContext';
import { trackActivity } from '../../../../utils/activityTracker'
import { UserContext } from '../../../../Context/UserContext'
import { InstanceContext } from '../../../../InstanceContext'

const GroupActionMenu = props => {

  const menuRef = useRef();
  const [showMenu, setShowMenu] = useState(false);
  const [action, setAction] = useState(null);
  const {controller, dtState} = React.useContext(DataTableContext);
  const { user } = React.useContext(UserContext)
  const { contextInstance } = React.useContext(InstanceContext)

  const handleActivityLogUpdate = (_id) => {
    trackActivity({
      body: {
        _id,
        instance: contextInstance || user.instance,
        user: user.id
      }
    })
  }

  if (controller.groupMenuActive && !showMenu) setShowMenu(true);

  const handleSelectAll = () => {
    setAction(null);
    controller.addAllToGroup();
    handleActivityLogUpdate(`GroupActionMenu.handleSelectAll`)
  }
  const handleUnselectAll = () => {
    setAction(null);
    controller.clearGroup();
    handleActivityLogUpdate(`GroupActionMenu.handleUnselectAll`)
  }

  const actionHandler = params => {
    setShowMenu(false);
    setAction(null);
    controller.handleGroupAction(params);
    handleActivityLogUpdate(`GroupActionMenu.actionHandler`)
  }

  const handleActionSelection = (actionID) => {
    if (controller.groupActions[actionID].actionOptions)
      setAction(actionID)
    else {
      actionHandler({
        actionID: actionID,
        actionParams: null
      });
      setAction(null);
      controller.setGroupMenuInactive();
    }
    handleActivityLogUpdate(`GroupActionMenu.handleActionSelection`)
  }

  const menuItems = React.useMemo(() => controller.groupActions ?
    Object.keys(controller.groupActions).map(actionID => {
      return(
        <Button
          key={actionID}
          onClick={handleActionSelection}
          clickParam={actionID}
          styles={action === actionID
            ? {
              ...styles.menuItem,
              ...styles.menuItemAct
            }
            : styles.menuItem}
          hoverStyles={styles.menuItemHov}
          activeStyles={styles.menuItemAct}
          focusStyles={styles.menuItemFoc}
        >
          {controller.groupActions[actionID].title}
        </Button>
      );
    }) : null, [controller.groupActions])

  const animation = {
    in: [
      ['opacity', {0: 0, 100: 1}, 280],
      ['transform', {0: 50, 100: 0}, 280, {easing: 'easeIn', valueMap: 'translateX($vpx)'}]
    ],
    out: [
      ['opacity', {0: 1, 100: 0}, 280],
      ['transform', {0: 0, 100: 50}, 280, {easing: 'easeOut', valueMap: 'translateX($vpx)'}]
    ]
  }

  const closeMenuCallback = () => {
    setAction(null)
    setShowMenu(false)
  }



  return( showMenu  ?
    <React.Fragment>
      <Animation
        condition={controller.groupMenuActive}
        animation={animation}
        callback={!controller.groupMenuActive ? closeMenuCallback : null}
        wrapStyles={styles.container}
      >
        <h5 style={styles.title}>Group Actions</h5>
        <div style={styles.content} ref={menuRef}>
          <Button
            key='dt_select_all_btn'
            onClick={handleSelectAll}
            styles={styles.menuItem}
            hoverStyles={styles.menuItemHov}
            activeStyles={styles.menuItemAct}
            focusStyles={styles.menuItemFoc}
          >
            Select All
          </Button>
          <Button
            key='dt_unselect_all_btn'
            onClick={handleUnselectAll}
            styles={styles.menuItem}
            hoverStyles={styles.menuItemHov}
            activeStyles={styles.menuItemAct}
            focusStyles={styles.menuItemFoc}
          >
            Unselect All
          </Button>
          {menuItems}
        </div>
      </Animation>
      <Animation
        condition={action !== null && showMenu !== false}
        animation={animation}
        wrapStyles={{...styles.subMenu, left: menuRef.current ? menuRef.current.clientWidth + 15 + 'px' : null}}
      >
      {action !== null &&
       controller.groupActions[action].actionOptions &&
        <div style={styles.actionSelect}>
        {controller.groupActions[action].actionOptions.map(option => {
          return(
            <Button
              key={option.value}
              onClick={actionHandler}
              clickParam={{actionID: action, actionParams: option.value}}
              styles={styles.menuItem}
              hoverStyles={styles.menuItemHov}
              activeStyles={styles.menuItemAct}
              focusStyles={styles.menuItemFoc}
            >
              {option.label}
            </Button>
          );
        })}
        </div>
      }
      </Animation>
    </React.Fragment>
  : null)
}

export default GroupActionMenu;
